import React from "react"
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { isNull, isEqual, isArray } from "lodash";

import {cloneObject, getParam} from '../utils/utils';
import {listDataSpecs, getDataSpec} from '../utils/utilsDataSpec';

import dsd from '../classes/clsDSD';

import * as PD from '../classes/pdStyle';

import Buffering from "../components/Buffering"; 



class SelectDataSpec extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            renderState: null
        };

        this.dsd = new dsd();

        this.handleChange = this.handleChange.bind(this);
    
    }

    componentDidMount(){

        this.setup();
 
     }
 
     componentDidUpdate(prevProps, prevState){
 
        if (!isEqual(this.props, prevProps)){
            this.setup();
        }

    }
 

    setup(){

        let StateChange = {
            renderState: null,
            label: "Data Spec",
            idSelected: "",
            onChange: null,
        }

        StateChange.name = getParam('name', this.props);

        if (getParam('label',this.props)){
            StateChange.label = getParam('label',this.props);
        }

        StateChange.idSelected = getParam('value', this.props);
        StateChange.onChange = getParam('onChange', this.props);

        this.setState(StateChange);

        this.loadDataSpecs();

    }



    loadDataSpecs(idInterface){

        this.setState({renderState: "loading"});

        const onLoad = (DataSpecs) => {
            this.setState({
                DataSpecs: DataSpecs,
                renderState: "loaded"
            });
        };

        const onError = (error) => {
            this.setState({
                renderState: "failed",
                errorMessage: error.message || "Failed to load data specs"
            });
        };

        let Filters = {};
        if (idInterface){
            Filters.idInterface = idInterface;
        }

        listDataSpecs(this.dsd, Filters, onLoad, onError);
        
    };



    handleChange(event) {

        const FormFieldName = event.target.name;
        let FormFieldValue = event.target.value;

        if (event.target.type == "checkbox"){
            FormFieldValue = event.target.checked;
        }

        switch (FormFieldName){
            default:
                let FormData = this.state.FormData;
                FormData[FormFieldName] = FormFieldValue;
                this.setState({"FormData": FormData});
                break;
        };

    };


    render() {

        switch (this.state.renderState){
            case "invalid":
            case "failed":
            case "denied":
                let Message = "An error has occured";
                if (this.state.errorMessage){
                    Message = this.state.errorMessage;
                }
                return <PD.ErrorBox>{Message}</PD.ErrorBox>
                break;
            case "loading":
                return <Buffering/>
                break;
            case "cancelled":
                return <p>Cancelled</p>
                break;
            case "loaded":

                return(
                    <>                    

                        {this.state.DataSpecs &&

                            <PD.Select label={this.state.label} name={this.state.name} onChange={this.state.onChange} value={this.state.idSelected}>
                                {
                                    this.state.DataSpecs.map(
                                        (DataSpec, pos) => 
                                            {
                                                return(
                                                    <option key={pos} value={DataSpec._id}>{DataSpec.name}</option>
                                                )
                                            }
                                    )
                                }
                            </PD.Select>
                        }

                    </>
                )
        }

    }
}


export default function SelectDataSpec_wrapper(props) {
    
    const navigation = useNavigate();
    const location = useLocation();
    const params = useParams();

    return <SelectDataSpec {...props} navigation={navigation} location={location} params={params} />;
  }
